import { observable } from 'mobx';

import { Model, App, ArrayApp, AppRegistry, ModelRegistry } from 'core/index';

export class UserModel extends Model {
  static registryName = 'UserModel';
  static ModelProps = {
    profile: 'ProfileModel',
  };

  @observable username = '@';
  @observable email = '';
  @observable profile = null;
}
ModelRegistry.add(UserModel);

export class UserApp extends App {
  static registryName = 'UserApp';
  static AppProps = {
    profile: 'ProfileApp',
  };

  static Model = UserModel;
  @observable password = '';
  @observable emailsEnabled = true;
}
AppRegistry.add(UserApp);

export class UserArrayApp extends ArrayApp {
  static registryName = 'UserArrayApp';
  static ElementApp = UserApp;
}
AppRegistry.add(UserArrayApp);
